"use client";
import r from "styled-components";
import e from "react";
import o from "./index.es102.js";
const i = r.div`
  a {
    text-decoration: none;
    display: block;
    width: 100%;
    &:link,
    &:visited,
    &:hover,
    &:active {
      color: #1a1a1a;
    }
    & *:first-child {
      display: flex;
      justify-content: space-between;
    }
  }
`, b = r(o)``, d = (t) => `/${process.env.NEXT_PUBLIC_STATS_BASE_URL}/${t}`, u = ({
  name: t,
  shortDescription: a,
  slug: l,
  linkTitle: s,
  linkDescription: m,
  linkExternal: c
}) => {
  const n = c || `/${l}`;
  return /* @__PURE__ */ e.createElement(i, { className: "bl-tile bl-tile--flat" }, !c && /* @__PURE__ */ e.createElement(b, { href: n }, /* @__PURE__ */ e.createElement("h3", { className: "bl-size-3 bl-m-b-3" }, s || t, /* @__PURE__ */ e.createElement("i", { className: "bl-icon--arrow-right" })), /* @__PURE__ */ e.createElement("div", { className: "bl-size-5" }, m || a)), !!c && /* @__PURE__ */ e.createElement(o, { href: d(c) }, /* @__PURE__ */ e.createElement("h3", { className: "bl-size-3 bl-m-b-3" }, s || t, /* @__PURE__ */ e.createElement("i", { className: "bl-icon--arrow-right" })), /* @__PURE__ */ e.createElement("div", { className: "bl-size-5" }, m || a)));
}, E = r.div``, v = ({ subjects: t, title: a }) => /* @__PURE__ */ e.createElement("div", { className: "bl-container bl-container--medium" }, /* @__PURE__ */ e.createElement("h2", { className: "bl-size-2 bl-m-b-3" }, a), /* @__PURE__ */ e.createElement(E, { className: "bl-grid bl-grid--two-columns bl-grid--small-row-gap" }, t.map((l) => /* @__PURE__ */ e.createElement(u, { ...l, key: `${l.slug}` }))));
export {
  v as default
};
//# sourceMappingURL=index.es62.js.map
